var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';

import Tip from "../../Layout/Tip";
import PropertyConfigOption from "./PropertyConfigOption";
import { Translate } from "../../I18N";
import PrioritySortingLabel from "./PrioritySortingLabel";

export class FormConfigCommon extends Component {
  getZeroIndex() {
    const { index, data } = this.props;
    const baseZeroIndex = index + data.commonProperties.length;
    return baseZeroIndex;
  }

  renderTitleField() {
    const { index, formState } = this.props;
    let labelClass = 'form-group';
    const labelKey = `commonProperties.${this.getZeroIndex()}.label`;
    const requiredLabel = formState.$form.errors[`${labelKey}.required`];
    const duplicatedLabel = formState.$form.errors[`${labelKey}.duplicated`];
    if (requiredLabel || duplicatedLabel) {
      labelClass += ' has-error';
    }

    return (/*#__PURE__*/
      _jsx("div", { className: labelClass }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: `label${index}` }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name")
      ), /*#__PURE__*/
      _jsx(Field, { model: `template.data.commonProperties[${this.getZeroIndex()}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `label${index}`, className: "form-control" })
      )
      ));

  }

  render() {
    const { index, data } = this.props;
    const property = data.commonProperties[this.getZeroIndex()];

    return (/*#__PURE__*/
      _jsx("div", {}, void 0,
      property.name === 'title' && this.renderTitleField(), /*#__PURE__*/
      _jsx(Field, { model: `template.data.commonProperties[${this.getZeroIndex()}].prioritySorting` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `prioritySorting${index}`, type: "checkbox" }), "\xA0", /*#__PURE__*/

      _jsx(PrioritySortingLabel, { htmlFor: `prioritySorting${index}` })
      ),
      property.name === 'title' && /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Generated ID",
        model: `template.data.commonProperties[${this.getZeroIndex()}].generatedId` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "A generated ID will be the default title.")
      )
      )

      ));

  }
}







export function mapStateToProps({ template }) {
  return {
    data: template.data,
    formState: template.formState
  };
}

export default connect(mapStateToProps)(FormConfigCommon);